const memberCN = {
    MEMBER_01:'Upload logo',
    MEMBER_02:'Please select industrys',
    MEMBER_03:'Please select countrys',
    MEMBER_04:'Save',
    MEMBER_05:'Please enter a number',
    MEMBER_06:'Please input the correct email address',
    MEMBER_07:'Upload avatar pictures can only jpg / jpeg / bmp / png format!',
    MEMBER_08:'Upload avatar picture size can not exceed 2MB!',
    MEMBER_09:'Please enter the origin password.',
    MEMBER_10:'Please enter the new password.',
    MEMBER_11:'Please re-enter the new password.',
    MEMBER_12:'Tips',
    MEMBER_13:'Confirm',
    MEMBER_14:'Password reset complete',
    MEMBER_15:'Upload avatar pictures can only be JPG!',
    MEMBER_16:'All Count',
    USE_BALANCE:'After out of quota,Paid with account balance when searching.'
}
export default memberCN


// WEBPACK FOOTER //
// ./src/lan/en/en_member.js